import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../core'
import * as healthCheck from '../health-check'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    constraints: {
      min: { value: 0 },
    },
    context: core.dms.models.Attribute.Id.Context.from(
      healthCheck.RESOURCE.payload,
    ),
    description:
      'Score for this level of the health check, calculated based on the criteria and dimensions below it.',
    isOptional: true,
    name: 'Score',
    partialId: PartialId.Standard.create('score'),
    type: core.common.value.types.Intrinsic.Decimal,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
